import React, { useEffect, useState } from "react";
import {
  IonButton,
  IonCard,
  IonContent,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonText,
  IonTitle,
  IonToggle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import Header from "src/components/Header";
import { search, time } from "ionicons/icons";
import "src/pages/PedidoProducto.css";
import {
  fetchMisPedidos,
  fetchPuntoServicio,
  IfetchPuntoServicio,
  RangoPedido,
  ToggleChangeEventDetail,
} from "src/services/PedidoDeProducto/pedido.producto.services";
import {
  fetchRangoPedido,
  fetchIniciarPP,
  fetchObtenerPedido,
  fetchCabeceraDetalle,
  fetchGestionJefatura,
  fetchGestionLideres,
  IEncuestaPedidoPendiente,
  IEncuestaPregunta,
} from "src/services/PedidoDeProducto/pedido.producto.services";
import EncuestaPedidoProducto from "src/components/pedidoProductos/EncuestaPedidoProducto";
import LoginAPI from "src/services/login";
import { cargoParaPedido } from "src/config/cargoPedido";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useHistory } from "react-router-dom";


// TD-11079: el estado sigue llamandose "Aprobación Gerencia Gentis" en la BD;
// al usuario se le muestra el nombre nuevo del area que aprueba.
const nombreEstado = (estado: string) =>
  estado === "Aprobación Gerencia Gentis"
    ? "Aprobación Gerencia Unidades Especializadas"
    : estado;

class errorMSG extends Error {
  constructor(error: string) {
    super(error);
    this.name = "errorMSG";
  }
}

interface MatchedPedidos {
  ps_objeto?: any;
  estado: string;
  excedente: number;
  facturar: any;
  id: number;
}

const PedidoDeProductos: React.FC = () => {
  const [cargo, setCargo] = useState("");
  const [cargoMostrar, setCargoMostrar] = useState("");
  const [pedidoPorFiscal, setPedidoPorFiscal] = useState({});
  const [pedidoPorJefes, setPedidoPorJefes] = useState({});
  const [estadoCabecera, setEstadoCabecera] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [facturado, setFacturado] = useState<boolean[]>([]);
  const [nuevoIngreso, setNuevoIngreso] = useState<boolean[]>([]);
  const [comodato, setComodato] = useState<boolean[]>([]);
  // TD-11079: pedido de EPIs, solo para los PS de una unidad que los maneja (GENTIS)
  const [epi, setEpi] = useState<boolean[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [PRE, setPre] = useState({});
  const [idPC, setIDPC] = useState(0);
  const [puntosDeServicio, setPuntosDeServicio] = useState<
    IfetchPuntoServicio[]
  >([]);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );
  const [errorMessagePresent, setErrorMessagePresent] = useState<
    string | undefined
  >(undefined);
  const [present] = useIonToast();
  const history = useHistory();
  const [psConPedidos, setPsConPedidos] = useState<MatchedPedidos[]>([]);

  // Encuesta post-pedido (TD-9465): se abre cuando fetchIniciarPP responde encuesta_pendiente.
  const [encuestaOpen, setEncuestaOpen] = useState(false);
  const [encuestaPedido, setEncuestaPedido] = useState<IEncuestaPedidoPendiente | null>(null);
  const [encuestaPreguntas, setEncuestaPreguntas] = useState<IEncuestaPregunta[]>([]);
  // Guardamos los argumentos del último intento de iniciarPP para reintentar al cerrar el modal.
  const [encuestaReintento, setEncuestaReintento] = useState<null | {
    punto: IfetchPuntoServicio;
    facturado: boolean[];
    nuevoIngreso: boolean[];
    comodato: boolean[];
    epi: boolean[];
    index: number;
  }>(null);

  useEffect(() => {
    const cargarPuntosDeServicio = async () => {
      if (searchValue.length < 3) {
        setErrorMessage(undefined);
        setPuntosDeServicio([]);
        return;
      }

      const resultado = await fetchPuntoServicio(searchValue);
      if (!resultado.error) {
        setErrorMessage(undefined);
        setPuntosDeServicio(resultado.datos);
      } else {
        setErrorMessage(resultado.error);
        console.error("Error al cargar puntos de servicio:", resultado.error);
        setPuntosDeServicio([]);
      }
    };
    cargarPuntosDeServicio();
  }, [searchValue]);

  useEffect(() => {
    if (errorMessagePresent) {
      present(errorMessagePresent, 6000);
      setErrorMessagePresent(undefined);
    }
  }, [errorMessagePresent, present]);

  useEffect(() => {
    const cargoPersonal = async () => {
      LoginAPI.me()
        .then((response) => {
          const usuario = response.data.datos;
          setCargo(cargoParaPedido(usuario.emp_cargo));
          setCargoMostrar(cargoParaPedido(usuario.emp_cargo));
        })
        .catch(() => { });
    };

    cargoPersonal();

    if (cargo === "JEFE DE OPERACIONES") {
      const gestion = fetchGestionJefatura();
      gestion
        .then((response) => {
          setPedidoPorFiscal(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (cargo === "GERENTE DE OPERACIONES") {
      const gestion = fetchGestionJefatura();
      gestion
        .then((response) => {
          const filtrado = {};
          for (const key in response) {
            if (
              !key.toUpperCase().includes("LIDER AGENTIS")
            ) {
              filtrado[key] = response[key];
            }
          }
          setPedidoPorJefes(filtrado);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (cargo.toUpperCase() == "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS") {
      fetchGestionJefatura()
        .then((response) => {
          // Adaptamos la respuesta para que encaje con la estructura que espera la vista
          const adaptado = {
            "UNIDADES ESPECIALIZADAS": response, // todo el array bajo una única clave
          };
          setPedidoPorJefes(adaptado);
        })
        .catch((error) => {
          console.error("Error al obtener pedidos para GERENTE DE GENTIS:", error);
        });
    }
    
    
    
  }, [cargo]);

  useEffect(() => {
    const misPedidosFetch = async () => {
      setLoading(true);
      try {
        const porPunto = await Promise.all(
          puntosDeServicio.map(async (punto) => {
            const data = await fetchMisPedidos({ limite: 5, ps: punto.ps_codigo }); // 👈 TOP 5 por PS
            const lista = data?.datos ?? [];
            // Normaliza los campos que usás en la vista
            return lista.map((pedido) => ({
              estado: pedido.estado || "",
              excedente: Number(pedido.excedente || 0),
              facturar: pedido.facturar ?? null,
              id: Number(pedido.id || pedido.id_pc || 0),
              ps_objeto: pedido.ps_objeto || punto.ps_codigo,
            }));
          })
        );

        // aplanar
        const matchedPedidos: MatchedPedidos[] = porPunto.flat();
        setPsConPedidos(matchedPedidos);
        setIDPC(matchedPedidos.length > 0 ? matchedPedidos[0].id : 0);
      } catch (error) {
        console.log(`ERROR: ${error}`);
      } finally {
        setLoading(false);
      }
    };

    const fetchEstados = async () => {
      setLoading(true);
      try {
        const estados = await Promise.all(
          puntosDeServicio.map(async (punto) => {
            const estado = await verificarEstadoCabecera(punto, idPC);
            return { punto, estado };
          })
        );
        setEstadoCabecera(estados);
        setErrorMessage("");
      } catch (error) {
        console.error("Error al obtener los estados:", error);
        setErrorMessage("Hubo un problema al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };

    if (puntosDeServicio.length > 0) {
      misPedidosFetch();
      fetchEstados();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [puntosDeServicio]);

const iniciarPP = async (
  punto: IfetchPuntoServicio,
  facturado: boolean[],
  nuevoIngreso: boolean[],
  comodato: boolean[],
  epi: boolean[],
  index: number
) => {
  // 1) CALCULAR facturarParams y pedidoData
  // Los switches se guardan por índice de tarjeta: se leen los de la tarjeta en la
  // que se tocó "INICIAR PEDIDO", no el primer valor cargado de cualquier tarjeta
  // (un switch apagado en otro PS pisaba el EPI encendido en este).
  const facturarParams = !!facturado[index];
  const nuevoIngresoParams = !!nuevoIngreso[index];
  const comodatoParams = !!comodato[index];
  const epiParams = !!punto.maneja_epi && !!epi[index];

  const puntoservicio_codigo = punto.ps_codigo;
  const pedidoData: any = {
    ps_objeto: puntoservicio_codigo,
    facturar: facturarParams ? 1 : 0,
    nuevo_ingreso: nuevoIngresoParams ? 1 : 0,
    comodato: comodatoParams ? 1 : 0,
    epi: epiParams ? 1 : 0,
    num_pre: facturarParams ? PRE[puntoservicio_codigo] || '' : '',
  };
  // log de debug con los datos del pedido que se enviaran al backend
  console.log('[PP][iniciarPP] payload enviar_pedido_cabecera', { puntoservicio_codigo, pedidoData, cargoMostrar });
  if (facturarParams && !pedidoData.num_pre) {
    present('El número de PRE es obligatorio.', 4000);
    return;
  }

  if (!facturarParams && !nuevoIngresoParams && !comodatoParams) { //si no es a facturar ni nuevo ingreso ni comodato validar los rangos de fecha y hora
    let rango: RangoPedido;
    try {
      // TD-11079: la ventana depende de la unidad de negocio del PS y de si el
      // pedido es de EPIs (que tiene su propia ventana y su propio tolerado)
      rango = await fetchRangoPedido(puntoservicio_codigo, epiParams);
    } catch (e: any) {
      present("No se pudo cargar el rango de fechas.", 4000);
      return;
    }

    // Guard: si la unidad de negocio del PS no tiene rango configurado en EMSYS, el
    // backend devuelve datos={} y los campos de fecha/hora vienen undefined. Cortamos
    // con un mensaje claro en vez de explotar al hacer .split sobre undefined.
    if (
      !rango ||
      !rango.hora_inicio_fiscal || !rango.hora_fin_fiscal ||
      !rango.hora_inicio_jefe   || !rango.hora_fin_jefe   ||
      !rango.fecha_inicio_fiscal || !rango.fecha_fin_fiscal ||
      !rango.fecha_inicio_jefe   || !rango.fecha_fin_jefe
    ) {
      present(
        epiParams
          ? "No hay un rango de fechas activo configurado en EMSYS para los pedidos de EPIs de este punto de servicio."
          : "No hay un rango de fechas activo configurado en EMSYS para la unidad de negocio de este punto de servicio.",
        5000
      );
      return;
    }

  const {
    fecha_inicio_fiscal,
    fecha_fin_fiscal,
    fecha_inicio_jefe,
    fecha_fin_jefe,
    hora_inicio_fiscal,
    hora_fin_fiscal,
    hora_inicio_jefe,
    hora_fin_jefe
  } = rango;

    // 1) Determina si es Fiscal o no
    console.log("🟡 cargoMostrar crudo:", cargoMostrar);
    const cargoUpper = cargoMostrar.toUpperCase();
    const esFiscal =
      cargoUpper.includes("FISCAL") ||
      cargoUpper.includes("LIDER AGENTIS") ||
      cargoUpper.includes("JEFE DE OPERACIONES ALTURA");
    console.log("🔵 esFiscal:", esFiscal);


    // 2) Crea fechas en local midnight
    const startDate = new Date(
      (esFiscal ? rango.fecha_inicio_fiscal : rango.fecha_inicio_jefe) + "T00:00:00"
    );
    const endDate = new Date(
      (esFiscal ? rango.fecha_fin_fiscal : rango.fecha_fin_jefe) + "T23:59:59"
    );
    const today = new Date();  

    // 3) Construir los Date para hora (hoy + hora)
    const [hfStartH, hfStartM, hfStartS] = 
      (esFiscal ? rango.hora_inicio_fiscal : rango.hora_inicio_jefe)
      .split(":").map(Number);
    const [hfEndH, hfEndM, hfEndS] = 
      (esFiscal ? rango.hora_fin_fiscal : rango.hora_fin_jefe)
      .split(":").map(Number);

    const startTime = new Date();
    startTime.setHours(hfStartH, hfStartM, hfStartS, 0);
    const endTime = new Date();
    endTime.setHours(hfEndH, hfEndM, hfEndS, 999);


    // 4) Validar fecha
    if (today < startDate || today > endDate) {
      const unidad = rango.unidad_negocio ? ` (${rango.unidad_negocio})` : "";
      present(`Fuera de fechas disponibles para tu rol${unidad}.`, 4000);
      return;
    }
    // 5) Validar hora: SOLO si hoy es el día de inicio o el día de fin del rango
    const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    if (todayDateOnly.getTime() === startDateOnly.getTime()) {
      // hoy es el primer día: verificar hora de inicio
      if (today < startTime) {
        present("Fuera del horario disponible para tu rol.", 4000);
        return;
      }
    } else if (todayDateOnly.getTime() === endDateOnly.getTime()) {
      // hoy es el último día: verificar hora de fin
      if (today > endTime) {
        present("Fuera del horario disponible para tu rol.", 4000);
        return;
      }
    }
  }

  // 3) si estamos dentro, sigue con el POST
  try {
    const resultado = await fetchIniciarPP(pedidoData);
    // log de debug con la respuesta al iniciar el pedido
    console.log('[PP][iniciarPP] respuesta fetchIniciarPP', resultado);

    // Bloqueo por encuesta pendiente (TD-9465): el backend respondió 409 y el servicio
    // propagó el body completo. Abrimos el modal y memorizamos los args para reintentar.
    if (resultado.encuesta_pendiente) {
      setEncuestaPedido(resultado.pedido ?? null);
      setEncuestaPreguntas(resultado.preguntas ?? []);
      setEncuestaReintento({ punto, facturado, nuevoIngreso, comodato, epi, index });
      setEncuestaOpen(true);
      return;
    }

    if (resultado.error) {
      present(resultado.error, 4000);
      return;
    }
  const detalle = await fetchObtenerPedido(resultado.id_pc);
  // log de debug con la respuesta de detalle de cabecera recien creada
  console.log('[PP][iniciarPP] respuesta fetchObtenerPedido', detalle);
  if (detalle.error) {
    present(detalle.error, 4000);
    return;
  }

  // ➡︎ Aquí redirigimos, pasando todo detalle en el state:
  history.push("/pedido-de-productos-detalles", {
    ...detalle,
    id_pc: Number(detalle.id_pc ?? detalle.id),  
    tolerado: Number(detalle.tolerado ?? 0),     
    facturado: Number(detalle.facturado ?? 0),   
    puntoservicio_codigo,
    facturarParams,
    cargo: cargoMostrar,
    comodato: comodatoParams,
  });
  } catch (error) {
    console.error('Error al iniciar el proceso:', error);
    present(
      'Ocurrió un error al iniciar el Pedido de Productos, comunícate con TI',
      4000
    );
  }
};



  const facturar = (index: number, checked: boolean) => {
    console.log(index, checked);
    const newFacturado = [...facturado];
    newFacturado[index] = checked;
    setFacturado(newFacturado);
  };

  const toggleNuevoIngreso = (index: number, checked: boolean) => {
    const newNuevoIngreso = [...nuevoIngreso];
    newNuevoIngreso[index] = checked;
    setNuevoIngreso(newNuevoIngreso);
  };

  const toggleEpi = (index: number, checked: boolean) => {
    const newEpi = [...epi];
    newEpi[index] = checked;
    setEpi(newEpi);
  };

  const toggleComodato = (index: number, checked: boolean) => {
    const newComodato = [...comodato];
    newComodato[index] = checked;
    setComodato(newComodato);
  };

  const handleInputChange = (codigoPuntoServicio, value) => {
    setPre((prevState) => ({
      ...prevState,
      [codigoPuntoServicio]: value, // Usa el código del punto de servicio como clave
    }));
  };

  const verificarEstadoCabecera = async (punto: IfetchPuntoServicio, idPC) => {
    console.log(punto, "punto");
    console.log(idPC, "idPC---------------------");

    if (idPC === 0) {
      return null;
    }

    try {
      const resultado = await fetchCabeceraDetalle(idPC);
      console.log(resultado.datos, "resultado");
      return resultado.datos;
    } catch (error) {
      console.error("Error al verificar estado de la cabecera:", error);
      return null;
    }
  };

  const handleVerPedido = async (idPC) => {
    let facturarParams = false;

    for (const key in facturado) {
      if (facturado[key] !== undefined) {
        facturarParams = facturado[key];
        break;
      }
    }

    console.log("facturaParams", facturarParams);
    console.log(idPC, "idPC");
    const detalleCab = await fetchCabeceraDetalle(idPC);

    // Arreglar estructura de datos para que coincida con lo que espera PedidoDeProductosDetalle
    history.push("/pedido-de-productos-detalles", {
      datos: detalleCab?.datos || detalleCab,  // Enviar datos con la estructura correcta
      id_pc: Number(detalleCab?.datos?.cabecera?.id || detalleCab?.id || idPC),
      tolerado: Number(detalleCab?.datos?.cabecera?.tolerado || detalleCab?.tolerado || 0),
      facturado: Number(detalleCab?.datos?.cabecera?.facturar || detalleCab?.facturado || 0),
      facturarParams,
      cargo: cargoMostrar,
    });
  };

  // Renderización condicional basada en el estado
  const renderVista = (cargo) => {
    const cargoUpper = String(cargo || "").toUpperCase();

    if (cargoUpper.includes("FISCAL") || cargoUpper.includes("LIDER AGENTIS") || cargoUpper.includes("JEFE DE OPERACIONES ALTURA")) {
      cargo = "fiscal";
    } else if (cargoUpper === "JEFE DE OPERACIONES") {
      cargo = "jefe";
    }
    if (cargo == "GERENTE DE OPERACIONES") {
      cargo = "gerente";
    }
    if (cargo == "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS") {
      cargo = "gerente";
    }
    
    switch (cargo) {
      case "fiscal":
        return (
          <>
            <div className="PP-titles">
              <IonItem style={{ borderRadius: 5 }}>
                <IonInput
                  clearInput={true}
                  value={searchValue ?? ""}
                  placeholder="Buscar Punto de servicio"
                  onIonChange={(e) => setSearchValue(e.detail.value ?? "")}
                ></IonInput>
                <IonIcon icon={search} />
              </IonItem>
            </div>
            <div className="ppContainer">
              <div className="PP">
                <p>
                  Realiza una busqueda de punto de servicio para realizar tu
                  pedido de producto
                </p>
                <div className="ppRow">
                  <IonCard className="pp_btn">
                    <img
                      width={50}
                      height={50}
                      src="assets/icon/pedidoProducto-COD1.svg"
                      alt="producto"
                    />
                    <h3>Pedido Producto</h3>
                  </IonCard>
                </div>

                {errorMessage ? (
                  <div className="PP">
                    <h5>{errorMessage}</h5>
                  </div>
                ) : loading ? (
                  <div className="PP">
                    <h5>
                      INGRESA AL MENOS 3 LETRAS PARA FILTRAR PUNTOS DE SERVICIOS
                    </h5>
                  </div>
                ) : estadoCabecera.length === 0 ? (
                  <div className="PP">
                    <h5>{`No se encontraron puntos de servicio con el filtro "${searchValue}"`}</h5>
                  </div>
                ) : (
                  estadoCabecera.map(({ punto }, index) => {
                    // Filtramos los pedidos que coinciden con el punto actual
                    const pedidosFiltrados = psConPedidos.filter(
                      (pedido: MatchedPedidos) =>
                        pedido.ps_objeto === punto.ps_codigo
                    );

                    return (
                      <IonCard className="PPCard">
                        <h2>{punto.ps_nombre}</h2>
                        <h4>{punto.ps_codigo}</h4>

                        <div className="PPCard_foot--end" key={index}>
                          {pedidosFiltrados.length > 0 ? (
                            pedidosFiltrados.map((pedido: MatchedPedidos) => {
                              if (pedido.estado !== null && !['Entregado/Finalizado', 'Rechazado', 'Cancelado', 'Iniciado'].includes(pedido.estado)) {
                                return (
                                  <IonText key={pedido.id}>
                                    El estado de su pedido está{" "}
                                    {nombreEstado(pedido.estado)}
                                    <h4>PEDIDO ID: {pedido.id}</h4>
                                    {pedido.excedente ? (
                                      <h4>
                                        PEDIDO EXCEDENTE: {pedido.excedente}%
                                      </h4>
                                    ) : (
                                      ""
                                    )}
                                  </IonText>
                                );
                              }

                            })

                          ) : (
                            <IonText >
                              Aún no realizó pedidos
                            </IonText>
                          )}

                        </div>
                        <br />
                        <div className="PPCard_foot--end--end">
                          <IonItem>
                            <IonLabel>¿A Facturar?</IonLabel>
                            <IonToggle
                              mode="ios"
                              aria-label="Danger toggle"
                              color="danger"
                              checked={!!facturado[index]}
                              onIonChange={(
                                e: CustomEvent<ToggleChangeEventDetail>
                              ) => {
                                const { checked } = e.detail;
                                facturar(index, checked);
                              }}
                            ></IonToggle>
                          </IonItem>

                          <IonItem>
                            <IonLabel>¿Primer Pedido?</IonLabel> {/* renombrar etiqueta según requerimiento */}
                            <IonToggle
                              mode="ios"
                              aria-label="Success toggle"
                              color="success"
                              checked={!!nuevoIngreso[index]}
                              onIonChange={(
                                e: CustomEvent<ToggleChangeEventDetail>
                              ) => {
                                const { checked } = e.detail;
                                toggleNuevoIngreso(index, checked);
                              }}
                            ></IonToggle>
                          </IonItem>

                          {punto.maneja_epi && (
                            <IonItem>
                              <IonLabel>¿Pedido de EPIs?</IonLabel>
                              <IonToggle
                                mode="ios"
                                aria-label="EPIs toggle"
                                color="tertiary"
                                checked={!!epi[index]}
                                onIonChange={(
                                  e: CustomEvent<ToggleChangeEventDetail>
                                ) => {
                                  const { checked } = e.detail;
                                  toggleEpi(index, checked);
                                }}
                              ></IonToggle>
                            </IonItem>
                          )}

                          <IonItem>
                            <IonLabel>¿A Comodato?</IonLabel>
                            <IonToggle
                              mode="ios"
                              aria-label="Comodato toggle"
                              color="tertiary"
                              checked={!!comodato[index]}
                              onIonChange={(
                                e: CustomEvent<ToggleChangeEventDetail>
                              ) => {
                                const { checked } = e.detail;
                                toggleComodato(index, checked);
                              }}
                            ></IonToggle>
                          </IonItem>

                          {facturado[index] === true && (
                            <div style={{ flexBasis: "5%" }}>
                              <IonInput
                                placeholder="Ingresa numero de PRE"
                                style={{
                                  fontWeight: "bold",
                                  color: "black",
                                  background: "rgba(255,255,255, 0.015)",
                                  boxShadow:
                                    "inset 0px 4px 4px rgba(0, 0, 0, 0.50)",
                                  borderRadius: "3px",
                                  marginBottom: 5,
                                }}
                                value={PRE[punto.ps_codigo] || ""}
                                onIonChange={(e) =>
                                  handleInputChange(punto.ps_codigo, e.detail.value)
                                }
                              />
                            </div>
                          )}

                          <div className="PPCard_foot--end">
                            <IonButton
                              onClick={() => iniciarPP(punto, facturado, nuevoIngreso, comodato, epi, index)}
                              id="tooltipFis"
                              shape="round"
                              expand="block"
                            >
                              INICIAR PEDIDO
                            </IonButton>
                          </div>
                        </div>
                      </IonCard>
                    );
                  })
                )}
              </div>
            </div>
          </>
        );
      case "jefe":
        return (
          <>
            <div className="PPCab">
              <h4>BANDEJA DE ENTRADA</h4>
            </div>
            <div className="PPJefatura">
              {Object.keys(pedidoPorFiscal).map((fiscal, index) => (
                <Accordion key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-${index}-content`}
                    id={`panel-${index}-header`}
                  >
                    {fiscal}
                  </AccordionSummary>
                  <AccordionDetails>
                    <IonList>
                      {Array.isArray(pedidoPorFiscal[fiscal]) ? (
                        pedidoPorFiscal[fiscal].map((pedido, pedidoIndex) => (
                          <IonItem key={pedidoIndex}>
                            <div style={{ flexGrow: 1 }}>
                              <p>
                                <strong>Punto Servicio:</strong>{" "}
                                {pedido.ps_nombre}
                              </p>
                              <p>
                                <strong>Estado:</strong> {nombreEstado(pedido.estado)}
                                {Number((pedido as any)?.comodato) === 1 && (
                                  <span
                                    style={{
                                      marginLeft: 8,
                                      padding: "2px 6px",
                                      borderRadius: 8,
                                      background: "#f59e0b",
                                      color: "#111827",
                                      fontWeight: 700,
                                      fontSize: 12,
                                    }}
                                  >
                                    Comodato
                                  </span>
                                )}
                              </p>
                              <p>
                                <strong>Fecha:</strong>{" "}
                                {pedido.fecha.split(" ")[0]}
                              </p>
                            </div>
                            <IonButton
                              onClick={() => handleVerPedido(pedido.id)}
                              color="primary"
                            >
                              Ver pedido
                            </IonButton>
                          </IonItem>
                        ))
                      ) : (
                        <p>No hay pedidos disponibles para este fiscal.</p>
                      )}
                    </IonList>
                  </AccordionDetails>
                  <AccordionActions>{`VISTA ${cargoMostrar}`}</AccordionActions>
                </Accordion>
              ))}
            </div>
          </>
        );
      case "gerente":
        return (
          <>
            <div className="PPCab">
              <h4>BANDEJA DE ENTRADA</h4>
            </div>
            <div className="PPJefatura">
              {Object.keys(pedidoPorJefes).map((fiscal, index) => (
                <Accordion key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-${index}-content`}
                    id={`panel-${index}-header`}
                  >
                    {fiscal}
                  </AccordionSummary>
                  <AccordionDetails>
                    <IonList>
                      {Array.isArray(pedidoPorJefes[fiscal]) ? (
                        pedidoPorJefes[fiscal].map((pedido, pedidoIndex) => (
                          <IonItem key={pedidoIndex}>
                            <div style={{ flexGrow: 1 }}>
                              <p>
                                <strong>Punto Servicio:</strong>{" "}
                                {pedido.ps_nombre}
                              </p>
                              <p>
                                <strong>Estado:</strong> {nombreEstado(pedido.estado)}
                              </p>
                              <p>
                                <strong>Fecha:</strong>{" "}
                                {pedido.fecha.split(" ")[0]}
                              </p>
                            </div>
                            <IonButton
                              onClick={() => handleVerPedido(pedido.id_pc ?? pedido.id)}
                              color="primary"
                            >
                              Ver pedido
                            </IonButton>
                          </IonItem>
                        ))
                      ) : (
                        <p>No hay pedidos disponibles para este fiscal.</p>
                      )}
                    </IonList>
                  </AccordionDetails>
                  <AccordionActions>{`VISTA ${cargoMostrar}`}</AccordionActions>
                </Accordion>
              ))}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const btnHistorial = {
    icono: time,
    action: () => history.push("/mis-pedidos"),
  };

  // El historial lo ven los solicitantes (sus pedidos) y jefatura/gerencia (los de su equipo).
  const cargoBoton = String(cargo || "").trim().toUpperCase();
  const mostrarBotonHistorial =
    cargoBoton.includes("FISCAL") ||
    cargoBoton.includes("LIDER AGENTIS") ||
    cargoBoton === "JEFE DE OPERACIONES" ||
    cargoBoton === "GERENTE DE OPERACIONES";

  const handleEncuestaCompletada = async () => {
    setEncuestaOpen(false);
    const pendiente = encuestaReintento;
    setEncuestaPedido(null);
    setEncuestaPreguntas([]);
    setEncuestaReintento(null);
    if (pendiente) {
      // Reintentar el flujo de iniciar pedido con los mismos parámetros.
      await iniciarPP(pendiente.punto, pendiente.facturado, pendiente.nuevoIngreso, pendiente.comodato, pendiente.epi, pendiente.index);
    }
  };

  const handleEncuestaCancelada = () => {
    setEncuestaOpen(false);
    setEncuestaPedido(null);
    setEncuestaPreguntas([]);
    setEncuestaReintento(null);
    present("Debe completar la encuesta para iniciar un nuevo pedido.", 4000);
  };

  return (
    <IonPage>
      <Header titulo={"PedidoDeProductos"} botonesDerecha={mostrarBotonHistorial ? [btnHistorial] : []}>
        <IonToolbar>
          <IonTitle>Pedido de Productos</IonTitle>
        </IonToolbar>
      </Header>
      <IonContent>{renderVista(cargo)}</IonContent>
      <EncuestaPedidoProducto
        open={encuestaOpen}
        pedido={encuestaPedido}
        preguntas={encuestaPreguntas}
        onCompleted={handleEncuestaCompletada}
        onCancel={handleEncuestaCancelada}
      />
    </IonPage>
  );
};

export default PedidoDeProductos;
